import { useRef, useState } from "react";
import image from "../assets/back.png";
import { Link } from "react-scroll";
import { services } from "./data/data";
import { motion } from "framer-motion";

// ✅ Animation wrapper with forwardRef
const Animation = ({ children, type, duration, delay }) => {
  return (
    <motion.div
      data-aos={type}
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration, delay }}
    >
      {children}
    </motion.div>
  );
};

const itemsPerPage = 4;

const Services = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(services.length / itemsPerPage);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentServices = services.slice(startIndex, startIndex + itemsPerPage);

  const nextPage = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  const prevPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  return (
    <div
      id="services"
      className="mt-[150px] md:mt-[450px] lg:mt-[150px] section"
    >
      <div className="container mx-auto lg:mt-[200px]">
        <div className="flex flex-col lg:flex-row">
          {/* left text */}
          <div className="flex-1 lg:w-1/2 relative mb-12 lg:mb-0">
            <img
              src={image}
              alt="image of a mac"
              className="hidden lg:flex absolute top-[20rem] z-[0] rounded-full mix-blend-lighten"
            />
            <div>
              <div className="h2 lg:mt-0 text-accent mb-6 font-extrabold">
                What I Do
              </div>
              <div className="h3 max-w-[455px] mb-16">
                I craft intuitive, responsive, and visually engaging digital
                experiences—blending design and functionality to make websites
                and applications both delightful and easy to use.
              </div>

              <Link activeClass="active" smooth={true} spy={true} to="work">
                <button className="btn btn-sm z-[50px] cursor-pointer relative">
                  My Projects
                </button>
              </Link>
            </div>
          </div>

          {/* right services */}
          <div className="lg:flex-2 lg:w-1/2">
            <div id="start">
              {currentServices.map((data, index) => (
                <Animation
                  key={data.id}
                  type="fade-up"
                  duration={0.6}
                  delay={index * 0.2}
                >
                  <div className="border-b border-white/20 mb-5 md:max-w-[500px] lg:max-w-[550px] flex">
                    <div className="md:mx-auto md:max-w-[500px] lg:max-w-[550px]">
                      <div className="font-extrabold text-[20px]">
                        {data.name}
                      </div>
                      <p>{data.description}</p>
                    </div>
                  </div>
                </Animation>
              ))}
            </div>

            {/* Pagination controls */}
            <Link
              offset={-50}
              smooth={true}
              to="start"
              className="flex justify-between items-center mt-6"
            >
              <button
                onClick={prevPage}
                disabled={currentPage === 1}
                className="btn btn-sm disabled:opacity-50"
              >
                Prev
              </button>
              <span className="text-sm font-semibold">
                Page {currentPage} of {totalPages}
              </span>
              <button
                onClick={nextPage}
                disabled={currentPage === totalPages}
                className="btn btn-sm disabled:opacity-50"
              >
                Next
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
